document.addEventListener('DOMContentLoaded', () => {
  const purchaseRadios = document.querySelectorAll('input[data-radio-type]');
  
  // Set default to 'subscription' if no preference is stored
  let currentPurchaseType = localStorage.getItem('selectedPurchaseType') || 'subscription';

  function updateBodyClass() {
    const subChecked = !!document.querySelector(
      'input[data-radio-type="selling_plan"]:checked, input[data-selling-plan-id]:checked'
    );
    document.body.classList.toggle('subscription-active', subChecked);
  }

  function applyPurchaseTypeToAllVariants(type) {
    purchaseRadios.forEach(radio => {
      if (type === 'subscription' && radio.matches('[data-radio-type="selling_plan"]')) {
        radio.checked = true;
      } else if (type === 'one-time' && radio.matches('[data-radio-type="one_time_purchase"]')) {
        radio.checked = true;
      }
    });
    updateBodyClass();
  }

  // Initial application based on stored selection or default
  applyPurchaseTypeToAllVariants(currentPurchaseType);

  purchaseRadios.forEach(radio => {
    radio.addEventListener('change', (event) => {
      currentPurchaseType = event.target.matches('[data-radio-type="selling_plan"]') ? 'subscription' : 'one-time';
      localStorage.setItem('selectedPurchaseType', currentPurchaseType);
      applyPurchaseTypeToAllVariants(currentPurchaseType);
    });
  });

  // Handle variant changes (Shopify specific event listener)
  document.addEventListener('variant:changed', () => {
    applyPurchaseTypeToAllVariants(currentPurchaseType);
  });
});
